"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = void 0;
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _Svg = require("../Svg");
var _excluded = ["withoutIconHover", "children"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NavLink = (0, _styledComponents.default)(function (_ref) {
  var withoutIconHover = _ref.withoutIconHover,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactstrap.NavLink, props, children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: all 0.1s ease-in-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: 4px;\n  border: none !important;\n  background-color: ", " !important;\n  color: ", " !important};\n  ", " {\n    margin-right: 7px;\n    path {\n      transition: fill 0.1s ease-in-out;\n      ", ";\n    }\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", " !important;\n    ", " path {\n      ", ";\n    }\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme,
    active = _ref2.active;
  return active && theme.colors.lightPrimary;
}, function (_ref3) {
  var theme = _ref3.theme,
    active = _ref3.active;
  return active ? theme.colors.primary : theme.colors.tertiary;
}, _Svg.Svg, function (_ref4) {
  var theme = _ref4.theme,
    active = _ref4.active,
    withoutIconHover = _ref4.withoutIconHover;
  return !withoutIconHover && "fill: ".concat(active ? theme.colors.primary : theme.colors.tertiary);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.lightPrimary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, _Svg.Svg, function (_ref7) {
  var theme = _ref7.theme,
    withoutIconHover = _ref7.withoutIconHover;
  return !withoutIconHover && "fill: ".concat(theme.colors.primary);
});
exports.NavLink = NavLink;